module.exports = __webpack_public_path__ + "01_veryshort_grey.311ea06a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_veryshort_grey.png
// module id = ONIk
// module chunks = 0